import React from "react";
// import { tooltips } from "../../../lib/utils/tooltips";
// import { InfoCard } from "../../shared/InfoCard/InfoCard";
// import { BillingProducts } from "./Products/BillingProducts";
import { BillingHelp } from "./Help/BillingHelp";
import { BillingAddProducts } from "./Products/BillingAddProducts";
import { SubscriptionsInfo } from "./SubscriptionsInfo/SubscriptionsInfo";

import "./Subscriptions.scss";

export const Subscriptions = () => {
  return (
    <div className="Subscriptions">
      <SubscriptionsInfo />
      <BillingHelp />
      <BillingAddProducts />
      {/* <InfoCard
        title="Products & Add-ons"
        message={tooltips.organizationSettings.subscription.products}
      >
        <BillingProducts />
      </InfoCard> */}
    </div>
  );
};
